import { Check, Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCopyToClipboard } from '@/hooks/use-copy-to-clipboard';
import { useToast } from '@/components/ui/toast';

interface CopyButtonProps {
  value: string;
  /** What was copied, for the tooltip / screen-reader label, e.g. "canonical URL". */
  label: string;
}

export function CopyButton({ value, label }: CopyButtonProps) {
  const { copied, copy } = useCopyToClipboard();
  const { toast } = useToast();

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="h-8 w-8 shrink-0"
      title={`Copy ${label}`}
      onClick={() => {
        void copy(value).then((ok) => {
          toast(
            ok
              ? { title: 'Copied to clipboard', description: label, variant: 'success' }
              : {
                  title: 'Could not copy',
                  description:
                    'Your browser blocked clipboard access. Select the text and copy it manually.',
                  variant: 'error',
                },
          );
        });
      }}
    >
      {copied ? (
        <Check aria-hidden="true" className="h-4 w-4 text-success" />
      ) : (
        <Copy aria-hidden="true" className="h-4 w-4" />
      )}
      <span className="sr-only">{copied ? `Copied ${label}` : `Copy ${label}`}</span>
    </Button>
  );
}
